var map = {
	"./breadcrumbs": [
		16375,
		6375
	],
	"./breadcrumbs.ts": [
		16375,
		6375
	],
	"./student": [
		99017,
		9017
	],
	"./student/": [
		99017,
		9017
	],
	"./student/index": [
		99017,
		9017
	],
	"./student/index.ts": [
		99017,
		9017
	],
	"./student/student": [
		15858,
		5858
	],
	"./student/student.tsx": [
		15858,
		5858
	],
	"./teacher": [
		95736,
		5736
	],
	"./teacher/": [
		95736,
		5736
	],
	"./teacher/index": [
		95736,
		5736
	],
	"./teacher/index.ts": [
		95736,
		5736
	],
	"./teacher/teacher": [
		7010,
		7010
	],
	"./teacher/teacher.tsx": [
		7010,
		7010
	],
	"./utils": [
		70236,
		236
	],
	"./utils.ts": [
		70236,
		236
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 43997;
module.exports = webpackAsyncContext;